export default {
  highlightOffer: (state) => state.highlightOffer,
  highlightDisplayTitle: (state) => state.highlightOffer.displayTitle,
  highlightIconImage: (state) => state.highlightOffer.iconImage,
  highlightBannerImage: (state) => state.highlightOffer.bannerImage,
  highlightTag: (state) => state.highlightOffer.tag,
  highlightModelType: (state) => state.highlightOffer.type,
  isExpandedModel: (state) => state.highlightOffer.type === 'EXPANDED',
  isDefaultModel: (state) => state.highlightOffer.type === 'DEFAULT',
  tagType: (state) => state.tagType,
  highlightStatus: (state) => state.status,
  isUsingHeaderImage: (state) => state.isUsingHeaderImage,
  highlightOfferSchedule: (state) => state.offerSchedule,
  highlightProducts: (state) => state.highlightProducts,
  highlightDates: (state) => state.highlightDates,
}
